import React, { useState, useEffect } from 'react';
import LegalService from './Service';
import './Components/LegalContent.css';

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setError(null);
        setLoading(true);

        const response = await LegalService.getPrivacyPolicy();

        setContent(
          response?.data?.content ||
          response?.data?.data ||
          response?.content ||
          response?.body?.content ||
          'Content not available'
        );
        setLoading(false);
      } catch (err) {
        console.error('Error fetching privacy content:', err);
        setError('Failed to load content. Please try again later.');
        setContent('Content not available at the moment.');
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <div className="legal-content-container">
      <div className="legal-content-header">
        <h1>Privacy Policy</h1>
      </div>

      <div className="legal-content-body">
        {/* ✅ Simple Loader */}
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading content...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <p>{error}</p>
          </div>
        ) : (
          <div className="legal-content-text">
            <div dangerouslySetInnerHTML={{ __html: content.content }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
